import format from 'date-fns/format';
import parse from 'date-fns/parse';
import addDays from 'date-fns/addDays'
import { DateUtils } from 'react-day-picker';
// Local Deps
import { DEFAULT_UI_DATE_FORMAT } from '../config/properties';

/*-------------------------------
    FORMAT DATE
--------------------------------*/
export function formatDate(date, dateFormat = DEFAULT_UI_DATE_FORMAT) {
  if (!date) return date;
  const formattedDate = format(date, dateFormat);
  return formattedDate;
}

/*-------------------------------
    CONVERT TO MS
--------------------------------*/
export function convertToMs(date, inputFormat = DEFAULT_UI_DATE_FORMAT) {
  if (!date) return date;
  // Parse date string
  const dateObject = parse(date, inputFormat, new Date());
  // Convert date string to MS
  const timeInMs = dateObject.valueOf();
  return timeInMs;
}

/*-------------------------------
    PARSE DATE
--------------------------------*/
export function parseDate(str, dateFormat) {
  const parsed = parse(str, dateFormat, new Date());
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

export function addDaysAndFormat (
  date,
  numberOfDays,
  dateFormat = DEFAULT_UI_DATE_FORMAT
) {
  const newDate = addDays(date, numberOfDays)
  const formattedDate = formatDate(newDate, dateFormat)
  return formattedDate
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js